import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

export const getHelloWorld = async () => {
  try {
    const { data } = await httpClient.get(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/hello`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postGroup = async (
  groupName,
  contributorName,
  contributorIcon,
  lang
) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/single`,
      { name: groupName, contributorName, contributorIcon, lang: lang }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const putGroup = async (groupId, contents) => {
  try {
    const { data } = await httpClient.put(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/${groupId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getGroup = async (groupId) => {
  try {
    const { data } = await httpClient.get(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/${groupId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postGroupSettle = async (groupId) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/${groupId}/settle`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postGroupResetSettlement = async (groupId) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/${groupId}/reset-settlement`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const patchSettlementItem = async (groupId, settlementItemId, contents) => {
  try {
    const { data } = await httpClient.patch(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/group/${groupId}/settlements/items/${settlementItemId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const putContributor = async (groupId, contributorId, contents) => {
  try {
    const { data } = await httpClient.put(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/contributor/${groupId}/${contributorId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postContributor = async (groupId, contents) => {
  try {
    const { data } = await httpClient.post(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/contributor/${groupId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteContributor = async (groupId, contributorId) => {
  try {
    const { data } = await httpClient.delete(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/contributor/${groupId}/${contributorId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postTransaction = async (groupId, contents) => {
  try {
    const { data } = await httpClient.post(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/${groupId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const putTransaction = async (groupId, transactionId, contents) => {
  try {
    const { data } = await httpClient.put(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/${groupId}/${transactionId}`,
      contents
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteTransaction = async (groupId, transactionId) => {
  try {
    const { data } = await httpClient.delete(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/${groupId}/${transactionId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteAffectedContributor = async (
  groupId,
  transactionId,
  contributorId
) => {
  try {
    const { data } = await httpClient.delete(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/affected/${groupId}/${transactionId}/${contributorId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postAffectedContributor = async (
  groupId,
  transactionId,
  contributorId
) => {
  try {
    const { data } = await httpClient.post(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/affected/${groupId}/${transactionId}`,
      { contributorId }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

// Upload a shareable image and get back an /api/images/:id proxy URL.
export const uploadImage = async (formData) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/images`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postTransactionReceipt = async (groupId, transactionId, formData) => {
  try {
    const { data } = await httpClient.post(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/${groupId}/${transactionId}/receipt`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getTransactionReceiptUrl = async (groupId, transactionId) => {
  try {
    const { data } = await httpClient.get(
      `${
        ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL
      }/api/v0/transaction/${groupId}/${transactionId}/receipt-url`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postDonationSession = async (payload) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/donations/create-session`,
      payload
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getLatestDonations = async (limit = 10) => {
  try {
    const { data } = await httpClient.get(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/donations/latest?limit=${limit}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDonationTotalForYear = async (year) => {
  try {
    const qs = year ? `?year=${encodeURIComponent(year)}` : "";
    const { data } = await httpClient.get(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/donations/total${qs}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postRoomFromGroup = async (groupId, gameType) => {
  try {
    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/v0/room/from-group`,
      { groupId, gameType }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
